import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import PropTypes from 'prop-types'
import React from 'react'
import ProductReviewCard from './product-review-card/ProductReviewCard'
import styles from './product-reviews-list.scss'

const ProductReviewsList = ({ productReviewsList }) => (
  <div
    data-cy="product-reviews-list-container"
    className="product-reviews-list-container"
  >
    <style jsx>{styles}</style>
    {productReviewsList.map((productReview) => (
      <div key={productReview?.id_product_review}>
        <ProductReviewCard productReview={productReview} />
      </div>
    ))}
  </div>
)

ProductReviewsList.defaultProps = {
  productReviewsList: [],
}

ProductReviewsList.propTypes = {
  // component props
  productReviewsList: PropTypes.arrayOf(
    PropTypes.shape({
      id_product_review: PropTypes.number,
      average_rating: PropTypes.number,
      content: PropTypes.string,
      create_ts: PropTypes.string,
      firstname: PropTypes.string,
      rating_design_and_style: PropTypes.number,
      rating_product_as_display: PropTypes.number,
      rating_product_quality: PropTypes.number,
      rating_true_to_size: PropTypes.string,
      size: PropTypes.string,
      title: PropTypes.string,
      user_height: PropTypes.string,
      user_weight: PropTypes.string,
      images: PropTypes.arrayOf(
        PropTypes.shape({
          id_product_review_image: PropTypes.number,
          image_url: PropTypes.string,
        }),
      ),
    }),
  ),
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
  })),
  withI18next(),
)(ProductReviewsList)
